import { format } from "date-fns";
import { TableColumn } from "react-data-table-component";

enum GENDER {
  MALE,
  FEMALE,
}

enum PERSON_TYPE {
  HocSinh,
  SinhVien,
  CongNhanVienChuc,
  LaoDongTuDo,
  NguoiCaoTuoi,
}

export const GENDERES = {
  [GENDER.MALE]: "Nam",
  [GENDER.FEMALE]: "Nữ",
};

export const PERSON_TYPES = {
  [PERSON_TYPE.HocSinh]: "Học sinh",
  [PERSON_TYPE.SinhVien]: "Sinh viên",
  [PERSON_TYPE.CongNhanVienChuc]: "Công nhân viên chức",
  [PERSON_TYPE.LaoDongTuDo]: "Lao động tự do",
  [PERSON_TYPE.NguoiCaoTuoi]: "Người cao tuổi",
};

export const genderOptions = Object.keys(GENDERES).map((key) => ({
  text: GENDERES[key],
  value: +key,
}));

export const personTypeOptions = Object.keys(PERSON_TYPES).map((key) => ({
  text: PERSON_TYPES[key],
  value: +key,
}));

const tableColumns: TableColumn<any>[] = [
  {
    name: "Tên",
    selector: ({ displayName }) => displayName,
  },
  {
    name: "Tài khoản",
    selector: ({ username }) => username,
  },
  {
    name: "Email",
    selector: ({ email }) => email,
  },
  {
    name: "Ngày sinh",
    selector: ({ dateOfBirth }) =>
      dateOfBirth ? format(dateOfBirth, "dd-MM-yyyy HH:mm") : "",
  },
  {
    name: "Giới tính",
    selector: ({ gender }) => GENDERES[gender],
  },
  {
    name: "Ngày tạo",
    selector: ({ createdDate }) =>
      createdDate ? format(createdDate, "dd-MM-yyyy HH:mm") : "",
  },
  {
    name: "Chức vụ",
    selector: (row) => row.userRole?.displayName,
  },
  {
    name: "Phân loại",
    selector: ({ typeOfPerson }) => PERSON_TYPES[typeOfPerson],
  },
  {
    name: "Bị khóa",
    selector: ({ isBlock }) => (isBlock ? "Có" : "Không"),
  },
];

export const formFields: any = [
  {
    name: "username",
    label: "Tài khoản",
  },
  {
    name: "displayName",
    label: "Tên",
  },
  {
    name: "email",
    label: "Email",
    type: "input",
  },
  {
    name: "dateOfBirth",
    label: "Ngày sinh",
  },
  {
    name: "gender",
    label: "Giới tính",
  },
  {
    name: "userRoleId",
    label: "Chức vụ",
  },
  {
    name: "typeOfPerson",
    label: "Phân loại",
  },
];

export { tableColumns };
